export enum Color {
  Black = 'black',
  White = 'white',
  Error = 'red',
  Success = 'green',
}
